import type { JSX } from 'react'
import type { ISkeletonProps } from '../Skeleton'

import {
  CategoriesTabsSkeletonUnit,
  ChannelDescriptionSkeletonUnit,
  ChannelInfoWrapperSkeletonUnit,
  ChannelLogoSkeletonUnit,
  ChannelProgramRowSkeletonUnit,
  ChannelTitleSkeletonUnit,
  DaysTabsSkeletonUnit,
  PlayerInfoBlockSkeletonUnit,
  PlayerSkeletonUnit,
  ProgramsListSkeletonUnit,
  TimeLineSkeletonUnit,
  TopPartSkeletonUnit,
} from '../components/SkeletonUnit/Templates'
import { Skeleton } from '../Skeleton'

export interface IEpgPageSkeletonProps extends ISkeletonProps {
  rowsCount?: number
}

export const EpgPageSkeleton = ({
  rowsCount = 6,
  ...rest
}: IEpgPageSkeletonProps): JSX.Element => (
  <Skeleton {...rest}>
    <TopPartSkeletonUnit>
      <CategoriesTabsSkeletonUnit />

      <PlayerInfoBlockSkeletonUnit>
        <PlayerSkeletonUnit />
        <ChannelInfoWrapperSkeletonUnit>
          <ChannelLogoSkeletonUnit />
          <ChannelTitleSkeletonUnit />
          <ChannelDescriptionSkeletonUnit />
        </ChannelInfoWrapperSkeletonUnit>
      </PlayerInfoBlockSkeletonUnit>

      <DaysTabsSkeletonUnit />
    </TopPartSkeletonUnit>

    <ProgramsListSkeletonUnit>
      <TimeLineSkeletonUnit />
      {new Array(rowsCount).fill('').map((_, index) => (
        <ChannelProgramRowSkeletonUnit key={index} />
      ))}
    </ProgramsListSkeletonUnit>
  </Skeleton>
)
